import { TFilters } from "@/types";

import { DEFAULT_PROJECTS_FILTERS } from "./CProjects";
import { DEFAULT_REPORT_FILTERS } from "./CReports";
import { DEFAULT_TASKS_FILTERS } from "./CTasks";

export const CHRONOS_FILTERS: TFilters = {
	projects: DEFAULT_PROJECTS_FILTERS,
	reports: DEFAULT_REPORT_FILTERS,
	tasks: DEFAULT_TASKS_FILTERS,
};

export const MIN_SEARCH_LENGTH = 3;
